import { useState, useEffect } from 'react';
import MatrixSLAHolidaysService from '../MatrixSLA/components/matrixSLAHolidays/services';
import { toast } from 'react-toastify';

export const useGetAllMatrixSLAHolidays = (id) => {
  const [matrixSLAHolidays, setMatrixSLAHolidays] = useState([]);
  const [loadingHolidays, setLoadingHolidays] = useState(false);

  const fetchMatrixSLAHolidays = () => {
    setLoadingHolidays(true);
    if (id) {
      MatrixSLAHolidaysService.getAllMatrixSLAHolidaysByMatrixSLAId(id)
        .then((res) => {
          const data = res.data.data.content;
          setLoadingHolidays(false);
          setMatrixSLAHolidays(data);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              err.message ||
              'Erro ao buscar feriados da Matriz SLA'
          );
          setLoadingHolidays(false);
        });
    }
  };

  useEffect(fetchMatrixSLAHolidays, [id]);

  return { matrixSLAHolidays, fetchMatrixSLAHolidays, loadingHolidays };
};
